import React from 'react'

import { IconSVGProps } from '@sidecar-components/atoms/Icon/Icon.types'

export const NoSwipe = ({
  className,
  pathClass,
  size = 6,
  ...rest
}: IconSVGProps) => (
  <svg
    aria-label="no swipe icon"
    className={`h-${size} w-${size} ${className}`}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      className={pathClass}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7 0L3 0L18 24H22L20.1238 20.9981C22.2757 20.9327 24 19.1677 24 17V10H13.25L11.375 7H24C24 4.79086 22.2091 3 20 3H8.875L7 0ZM2.24672 3.40372C0.916374 4.05351 0 5.41974 0 7H4.44444L2.24672 3.40372ZM0 10H6.27778L13 21H4C1.79086 21 0 19.2091 0 17L0 10Z"
    />
  </svg>
)
